// Sweetalert mixin
const SwalBootstrap = Swal.mixin({
    buttonsStyling: false,
    scrollbarPadding: false,
    customClass: {
        cancelButton: 'btn btn-muted',
        confirmButton: 'btn btn-primary',
    },
});

// Show the default loader box
$.showLoader = function () {
    SwalBootstrap.fire({
        allowEnterKey: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        html: `<div class="loader">
            <div class="spinner-border"></div>
        </div>`,
    });
}

// Smooth scroll to specific position
$.scrollTo = function (position, target = 'html, body', duration = 0) {
    $(target).animate({
        scrollTop: position,
    }, duration);
}

// Redirect or reload to specific page
$.redirectTo = function (url) {
    window.location.href = url;
    if (/(^|\B)#(?![0-9_]+\b)([a-zA-Z0-9_]{1,})(\b|\r)/.test(url)) {
        window.location.reload();
    }
}

// Popup new window with settings
$.popupTo = function (url, title) {
    var width = 1024;
    var height = 768;
    var left = (screen.width / 2) - (width / 2);
    var top = (screen.height / 2) - (height / 2);

    return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);
}

// Focus input based on event errors
$.focusOnError = function (e) {
    if (e.responseJSON.errors !== undefined) {
        $('[name*="password"]').val('');
        $('[name="' + Object.keys(e.responseJSON.errors)[0] + '"]').trigger('focus');
    }
}

// Handle HTTP success responses
$.handleSuccess = function (e, onClose = () => { }) {
    SwalBootstrap.fire({
        didClose: onClose,
        icon: 'success',
        showConfirmButton: false,
        text: e?.data?.message,
        timer: 2000,
        title: 'Success.',
    });
}

// Handle HTTP error responses
$.handleError = function (e, onClose = () => { }) {
    switch (e.status) {
        case 500:
            SwalBootstrap.fire({
                icon: 'error',
                text: 'We have encountered an unexpected error. Kindly contact the site developer for more details.',
                title: 'Unexpected Error.',
                didClose: () => {
                    // window.location.reload();
                },
            });
            break;
        case 403:
            SwalBootstrap.fire({
                icon: 'error',
                text: 'Your action is unauthorized. Kindly try again using the correct account with the relevant privilege.',
                title: 'Unauthorized Action.',
                didClose: onClose,
            });
            break;
        case 422:
            SwalBootstrap.fire({
                icon: 'error',
                text: e.responseJSON.errors[Object.keys(e.responseJSON.errors)[0]][0],
                title: e.responseJSON.message,
                didClose: onClose,
            });
            break;
        case 400:
        case 401:
        default:
            SwalBootstrap.fire({
                icon: 'error',
                text: e.responseJSON.message,
                title: 'Error.',
                didClose: onClose,
            });
    }
}

// Prompt Confirmation
$.promptConfirmation = function (message, onConfirm = () => { }, onCancel = () => { }) {
    SwalBootstrap.fire({
        confirmButtonText: 'Confirm',
        icon: 'warning',
        showCancelButton: true,
        text: message,
        title: 'Confirmation',
    }).then(result => {
        result.value ? onConfirm() : onCancel();
    });
}
